import Vue from 'vue';
import VueRouter from 'vue-router';

const dashboard = () => import ('./pages/Dashboard')
const builder = () => import ('./pages/Builder')
const companies = () => import ('./pages/Companies')
import Proposal from './pages/Proposal'
import NotFound from './pages/404'

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'Dashboard',
			component: dashboard
		}, {
			path: '/builder',
			name: 'Builder',
			component: builder,
			//	beforeEnter: guardRoute

		}, {
			path: '/companies',
			name: 'Companies',
			component: companies,
		}, {
			path: '/proposal',
			name: 'Proposal',
			component: Proposal,
			//	beforeEnter: guardRoute

		}, {
			path: '/*',
			component: NotFound
		}
	]
})

function guardRoute(to, from, next) {
	// work-around to get to the Vuex store (as of Vue 2.0)
	const auth = router.app.$options.store.state.auth

	if (!auth.isLoggedIn) {
		next({
			path: '/',
			query: {
				redirect: to.fullPath
			}
		})
	} else {
		next()
	}
}

export default router;



// WEBPACK FOOTER //
// ./src/router.js